__turbopack_context__.v({
  "fullVideo": "Vu3GpG_fullVideo",
  "leftVideo": "Vu3GpG_leftVideo",
  "rightVideo": "Vu3GpG_rightVideo",
  "youTubeCaption": "Vu3GpG_youTubeCaption",
});
